import {calendar_api} from "@/store/resources";

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        createPlannedTransaction: ({}, data) => calendar_api.calendarTemplates.save(data),
        updatePlannedTransaction: ({}, data) => calendar_api.calendarTemplates.update({id: data.id}, data),
        removePlannedTransaction: ({}, id) => calendar_api.calendarTemplates.delete({id}),

        fetchTemplateTransactions: ({}, query) => calendar_api.calendarTemplates.get(query),
        archiveTemplateTransaction: ({}, id) => calendar_api.calendarTemplates.delete({id}),
    },
    mutations: {}
}